import FeedbackComponent from "./FeedbackComponent.jsx";
import KeyInformation from "./KeyInformation.jsx";
import TotalAttendees from "./TotalAttendees.js";
import UploadFiles from "./UploadFiles.jsx";
import useFormContext from "./useFormContext.js";

const Summary = () => {
    const { eventFormData } = useFormContext();

    const content = (
        <>
            <div className="col-md-10 mb-3">
                {/* Key Information */}
                <div className="container bg-light rounded p-2 mt-2 mb-1">
                    <KeyInformation eventId={eventFormData.eventId} />
                </div>

                {/* total attendees */}
                <div className="container bg-light rounded p-2 mt-2 mb-1">
                    <TotalAttendees></TotalAttendees>
                </div>

                {/* feedback */}
                <FeedbackComponent eventId={eventFormData.eventId} />

                {/* files upload and display  */}
                <UploadFiles></UploadFiles>
            </div>
        </>
    );
    return content;
};
export default Summary;